import { Tag } from 'antd';
import { TreeSelectProps } from 'antd/lib';
import { SorterResult } from 'antd/lib/table/interface';

import { getEnTranslation, getFrTranslation } from 'utils';

import { REGIONS } from 'consts';

import { Retailer, RetailerGroupDto } from 'codegen';
import { TColumn, TEditableColumn, TFieldProps } from 'types';

export const getFormattedRetailerGroups = (retailersGroup: RetailerGroupDto & { id: number }) => ({
  ...retailersGroup,
  retailers: retailersGroup.retailers.map((retailer) => ({
    ...retailer,
    label: retailer.name,
    value: `${retailer.id}-${retailer.companyId}`,
  })),
});

export const retailerColumns = (isAdmin?: boolean, sortOrderInfo?: SorterResult<Retailer>): TColumn<Retailer>[] => [{
  type: isAdmin ? TColumn.type.IDRedirect : undefined,
  width: 70,
  title: 'ID',
  dataIndex: 'id',
  showSorterTooltip: true,
  sorter: true,
  sortOrderInfo,
}, {
  width: 200,
  title: 'Retailer Name in English',
  dataIndex: 'retailerNameEn',
  render: (_, record) => {
    const en = getEnTranslation(record.translations);

    return en?.name;
  },
}, {
  width: 200,
  title: 'Retailer Name in French',
  dataIndex: 'retailerNameFr',
  render: (_, record) => {
    const fr = getFrTranslation(record.translations);

    return fr?.name;
  },
}, {
  width: 250,
  type: TColumn.type.Ellipsis,
  title: 'Company Name in English',
  dataIndex: 'company.englishName',
}, {
  width: 250,
  type: TColumn.type.Ellipsis,
  title: 'Company Name in French',
  dataIndex: 'company.frenchName',
}, {
  width: 400,
  title: 'Regions',
  dataIndex: 'regions',
  render: (values) => {
    const regions = REGIONS.reduce<string[]>((acc, item) => {
      const { children } = item;

      children.forEach(({ value, title }) => {
        if (values.includes(value)) {
          acc.push(title);
        }
      });

      return acc;
    }, []);

    return regions.map((region) => <Tag key={region}>{region}</Tag>);
  },
}, {
  width: 150,
  title: 'Sponsor Code',
  dataIndex: 'sponsorCode',
  sorter: true,
  sortOrderInfo,
}, {
  width: 100,
  type: TColumn.type.Status,
  title: 'Status',
  dataIndex: 'status',
}];

export const retailerGroupsColumns = (retailers?: TreeSelectProps['treeData']): TEditableColumn<RetailerGroupDto>[] => [{
  width: 70,
  title: 'ID',
  dataIndex: 'id',
}, {
  width: 200,
  title: 'Retailer Group Name',
  dataIndex: 'groupName',
  field: {
    type: TFieldProps.type.Text,
    placeholder: 'Enter name',
    rules: [{
      message: 'Required',
      required: true,
      transform: (value) => value.trim(),
    }],
  },
}, {
  type: TColumn.type.Tags,
  width: 350,
  title: 'Retailers',
  dataIndex: 'retailers',
  field: {
    type: TFieldProps.type.TreeSelect,
    treeData: retailers,
    placeholder: 'Select Retailer(s)',
    rules: [{
      message: 'Required',
      required: true,
    }],
  },
}];
